import {env} from "../../../../../res/config/env";
import HttpClient from "../../../http/HttpClient";

const poAcknowledgementRequest = () => {

    const builder = {}
    const params = { action: "acknowledge" };

    builder.token = (token) => {
        params.token = token;
        return builder;
    }

    builder.sendIt = async () => {
        const url = env.API_URL +  "/api/v1/models/purchase_order";
        const paramString = "?token=" + params.token + "&action=" + params.action;
        const resp = await HttpClient.client.put(url + paramString, {});
        return resp.data;
    }

    return builder;
}

export default poAcknowledgementRequest;
